export function getItem(key) {
    try {
        return window.localStorage.getItem(key);
    }
    catch (e) {
        return undefined;
    }
}
export function setItem(key, value) {
    try {
        window.localStorage.setItem(key, value);
    }
    catch (e) {
        console.warn(e);
    }
    finally {
        return value;
    }
}
